import DirectCall from './DirectCall';
import GroupMeeting from './GroupMeeting';
import VideoMeetings from './VideoMeetings';
import useVideoMeetingsFunctions from './useVideoMeetingsFunctions';

const VideoMeetingsScreen = () => {
  const { selectedUser, setSelectedUser, availableUsers, loading, mode, setMode, handleDirectCall, handleStartGroupMeeting } = useVideoMeetingsFunctions();

  if (mode === null) {
    return <VideoMeetings setMode={setMode} />;
  }

  if (mode === 'direct-call') {
    return (
      <DirectCall
        setMode={setMode}
        availableUsers={availableUsers}
        loading={loading}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        handleDirectCall={handleDirectCall}
      />
    );
  }

  if (mode === 'group-meeting') {
    return <GroupMeeting setMode={setMode} handleStartGroupMeeting={handleStartGroupMeeting} />;
  }
};

export default VideoMeetingsScreen;
